import LegalLayout from "@/components/layout/LegalLayout";

const SECTIONS = [
    {
        h: "1. Postanowienia ogólne",
        p: [
            "Niniejszy regulamin określa zasady korzystania ze strony internetowej Groszownik dostępnej pod adresem groszownik.io oraz z formularza listy oczekujących.",
        ],
    },
    {
        h: "2. Definicje",
        p: [
            "Serwis — strona marketingowa Groszownik. Użytkownik — osoba korzystająca z Serwisu. Lista oczekujących — formularz zapisu na informację o premierze aplikacji.",
        ],
    },
    {
        h: "3. Zasady korzystania",
        p: [
            "Korzystanie z Serwisu jest bezpłatne. Użytkownik zobowiązuje się do podawania prawdziwych danych oraz do niepodejmowania działań zakłócających funkcjonowanie Serwisu.",
        ],
    },
    {
        h: "4. Lista oczekujących",
        p: [
            "Zapis na listę oczekujących jest dobrowolny i wymaga podania adresu e-mail. Rejestracja nie stanowi zawarcia umowy o świadczenie usług aplikacji ani gwarancji dostępu do niej.",
        ],
    },
    {
        h: "5. Własność intelektualna",
        p: [
            "Wszelkie treści, znaki towarowe i materiały graficzne w Serwisie są chronione prawem i należą do Groszownik lub są wykorzystywane na podstawie odpowiednich licencji.",
        ],
    },
    {
        h: "6. Reklamacje i kontakt",
        p: [
            "Uwagi i reklamacje dotyczące działania Serwisu będzie można zgłaszać kanałem kontaktowym, który udostępnimy wkrótce. Odpowiemy w rozsądnym terminie.",
        ],
    },
];

export default function TermsPage() {
    return (
        <LegalLayout
            title="Regulamin"
            path="/regulamin"
            description="Regulamin korzystania ze strony Groszownik i listy oczekujących."
            updated="12 lipca 2026"
            sections={SECTIONS}
        />
    );
}
